<template>
	<div>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="结果" goBack="true"></head-top>
		<div class="con">

			<div class="exam_name ellipsis_1 font_size_c">
				{{categoryExamName}}
			</div>

			<div class="star_container flex_d">
				<van-rate :value="parseInt(accuracy/20)" readonly size="30" gutter="20" color="orange" void-color="#D4D4D4"
				 void-icon="star" />
			</div>

			<div class="flex_a card_index_list">
				<div v-for="(item,index) in list" :key="item.id" style="width: 20%;" class="flex_d">
					<div class="card_circle" :class="[(item.userAnswer != null && item.userAnswer == item.answerForOption)?'active_right':'',(item.userAnswer != null && item.userAnswer != item.answerForOption)?'active_wrong':'' ]">
						{{index+1}}
					</div>
				</div>
			</div>

			<div class="result_txt">共<span>{{length}}</span>题</div>
			<div class="result_txt">正确率: <span>{{accuracy}}</span>%</div>

			<div class="foot flex_c">
				<van-button class="btn" @click="toAnalysisPage" color="linear-gradient(to right, #f450e6, #e22020)">
					查看解析
				</van-button>
				<van-button class="btn" @click="toIndexPage" color="linear-gradient(to right, #6050f4, #50b8f4)">
					返回首页
				</van-button>
			</div>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import Draw from "@/utils/canvas";
	import api from "@/apis/api";
	import {
		mapGetters
	} from "vuex";
	export default {
		name: "PracticeChapterResult",
		components: {
			headTop: headTop
		},
		data() {
			return {
				resourceDomain: api.resourceDomain,
				accuracy: '',
				replyNum: 0,
				length: 0,
				categoryExamName: '',
				list: [],
				practiceRecordId: 0,
			};
		},
		created() {
			this.practiceRecordId = this.$route.query.practiceRecordId
			this.updatePage()
		},
		methods: {
			// 调用组件中的登录成功里的自定义的更新数据事件
						updatePage() {
							// 章节练习交卷结果
							this.chapterSubmitResult();
						},
						
			// 章节练习交卷结果
			chapterSubmitResult() {
				let id = this.practiceRecordId
				api.get(`/mp/practice/question/chapterSubmitResult/${id}`).then(res => {
					this.accuracy = res.data.accuracy
					this.replyNum = res.data.replyNum
					this.length = res.data.length
					this.categoryExamName = res.data.chapterName
					this.list = res.data.list
				})
			},

// 返回首页
			toIndexPage() {
				this.$router.replace({
					path: '/main/practice_index'
				})
			},

			//跳转解析页面
			toAnalysisPage() {
				this.$router.replace({
					'path': '/practice_chapter_history_detail',
					query: {
						id: this.practiceRecordId
					}
				})
			},
		}
	};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
	.con {
		padding-top: 48px;
	}

	.result_txt {
		font-size: 20px;
		color: #333;
		text-align: center;
		padding: 10px;
	}

	.result_txt span {
		color: #F45250;
		font-weight: 700;
		padding: 5px;
	}

	.exam_name {
		width: 355px;
		background-color: #f9f9f9;
		text-align: center;
		padding: 10px;
	}

	.star_container {
		padding: 40px 0;
	}

	.card_index_list {
		width: 345px;
		padding: 0 15px;
		margin-bottom: 20px;
		flex-wrap: wrap;
	}

	.card_circle {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		border: 1px solid #bfbfbf;
		text-align: center;
		line-height: 30px;
		font-size: 15px;
		margin-bottom: 15px;
		color: #999999;
	}

	.card_circle.active {
		border: 1rpx solid #00b7ee;
		background: #00b7ee;
		color: white;
	}

	.active_right {
		background-color: #00b7ee;
		color: #FFF;
		border: none;
	}

	.active_wrong {
		background-color: red;
		color: #FFF;
		border: none;
	}

	.foot {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 375px;
		z-index: 999;
		color: #FFF;
		text-align: center;
	}

	.btn {
		width: 50%;
		height: 45px;
		line-height: 45px;
		border-radius: 0 !important;
	}
</style>
